/**
 * FoodPreferencesStep.validation.js
 *
 * Pure function, no React — mirrors LifestyleStep.validation.js /
 * ActivityLevelStep.validation.js / MedicalInfoStep.validation.js.
 * FoodPreferencesStep only consumes `isValid` to drive
 * AssessmentStepShell's `nextDisabled`; `errors` is returned too in case
 * a future screen wants field-level messaging.
 */

export function validateFoodPreferences(data) {
  const errors = {};

  if (!data.dietType) {
    errors.dietType = "Please select a diet type.";
  }
  if (!Array.isArray(data.cuisines) || data.cuisines.length === 0) {
    errors.cuisines = "Please select at least one cuisine.";
  }
  if (!data.cookingTime) {
    errors.cookingTime = "Please select a cooking time.";
  }
  if (!data.budget) {
    errors.budget = "Please set your budget.";
  }

  return { isValid: Object.keys(errors).length === 0, errors };
}